import React from "react";
import { Box, Typography } from "@mui/material";
import { useLocation, Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { pageCourante } from "../navigation/plan";
import { COULEUR_DOMAINE } from "../theme/tribeTheme";
import { CarreDomaine } from "./charte/Bloc";

/* En-tête : fil d'Ariane « Accueil › Entrée du menu › Page », lu dans le
   plan du back-office (navigation/plan.ts). Plus de bascule sombre/clair :
   la charte n'a qu'une variante. */
export default function Header() {
  const location = useLocation();
  const pageTitle = useSelector((s: RootState) => s.pageTitle);
  const { entree, titre, horsMenu } = pageCourante(location.pathname, location.search);

  const lien = (to: string, texte: string) => (
    <RouterLink to={to} style={{ textDecoration: "none" }}>
      <Typography sx={{ fontSize: "13px", color: "var(--c-text-secondary)", lineHeight: 1, whiteSpace: "nowrap", "&:hover": { color: "var(--c-text-primary)", textDecoration: "underline" } }}>
        {texte}
      </Typography>
    </RouterLink>
  );
  const courant = (texte: string) => (
    <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "var(--c-text-primary)", lineHeight: 1, whiteSpace: "nowrap" }}>{texte}</Typography>
  );
  const sep = <ChevronRightRoundedIcon sx={{ fontSize: 15, color: "var(--c-text-secondary)", flexShrink: 0 }} />;
  // Page hors menu (détail d'une quête…) : le titre posé par la page elle-même.
  const titrePage = horsMenu ? (pageTitle || titre) : titre;

  return (
    <Box component="header" sx={{
      position: "sticky", top: 0, zIndex: 100,
      background: "var(--c-bg)",
      borderBottom: "1px solid var(--c-border)",
      px: 3.5, height: "52px", minHeight: "52px", maxHeight: "52px", flexShrink: 0,
      display: "flex", alignItems: "center", gap: 2,
    }}>
      <Box component="nav" aria-label="Fil d'Ariane" sx={{ display: "flex", alignItems: "center", gap: 0.75, minWidth: 0 }}>
        {entree?.cle === "accueil" ? courant("Accueil") : lien("/accueil", "Accueil")}
        {entree && entree.cle !== "accueil" && (
          <>
            {sep}
            <CarreDomaine couleur={COULEUR_DOMAINE[entree.cle]} taille={8} />
            {titrePage ? lien(entree.chemin, entree.libelle) : courant(entree.libelle)}
          </>
        )}
        {entree && titrePage && (
          <>
            {sep}
            {courant(titrePage)}
          </>
        )}
      </Box>
    </Box>
  );
}
